module.exports = __webpack_public_path__ + "img/3.ec9c4198.png";